import httpClient from '../../api/axios-httpclient';
import InvoicesCheckingUpdateAPI from '@/api/InvoicesCheckingUpdateAPI.js';
import commonFunc from '@/common/commonFunction';
import { MSEnum } from '@/common/enumeration';
export default {
	loadInvoicesCheckingUpdateOrganization: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: `${InvoicesCheckingUpdateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/checkingupdatebylstorg`,
			data: payload
		});
		if (!res || !res.Success) return null;
		res.Data = commonFunc.sortDataInfoAccept(res.Data, [
			MSEnum.KindChange.BuyerStatusAddress,
			MSEnum.KindChange.BuyerStatusName
		]);
		context.commit('updateInvoicesCheckingUpdateOrganization', res.Data);
		return res.Data;
	},

	loadInvoicesCheckingUpdateSupplier: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: `${InvoicesCheckingUpdateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/${
					payload.IdentificationNumber ? payload.IdentificationNumber : payload.TaxCode
				}?orgIdQuery=${payload.OrgId}`
			},
			true
		);
		if (!res || !res.Success) return null;

		let lstEnums = [MSEnum.KindChange.SellerStatusAddress, MSEnum.KindChange.SellerStatusName];
		if (payload.IsCheckThirdParty) {
			// Nếu là cctc đặc thù thì lấy lên cả thông tin chấp nhận ở cả người mua và người bán
			lstEnums = [...lstEnums, MSEnum.KindChange.BuyerStatusAddress, MSEnum.KindChange.BuyerStatusName];
		}
		res.Data = commonFunc.sortDataInfoAccept(res.Data, lstEnums);
		context.commit('updateInvoicesCheckingUpdateSupplier', res.Data);
		return res.Data;
	},

	addManyInvoiceChecking: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${InvoicesCheckingUpdateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/insertmany`,
				data: payload
			},
			true
		);
		return res;
	},
	deleteManyInvoiceChecking: async function(context, payload) {
		let res = await httpClient.deleteAsync(
			{
				url: `${InvoicesCheckingUpdateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/deletemany`,
				data: payload
			},
			true
		);
		return res;
	}
};
